/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import TextElement from "../TextElement.jsx";
import {CgSpinner} from "react-icons/cg";
import {Subscription} from "../../Subscription.js";
import {Socket} from "../../Socket.js";
import {Util} from "../../Utilities.js";
import {formatDistanceToNowStrict, formatDuration, intervalToDuration} from "date-fns";
import DisplayUpdatedValue from "../DisplayUpdatedValue.jsx";
import {BuildsAPI} from "../../APIs/BuildsApi.js";

class DeploymentHistory extends Component {

    constructor() {
        super();
        this.state = {
            allBuilds: [],
        }

        this.sub = new Subscription()

    }

    async fetchData() {
        let {imageId} = this.props

        let buildsResult = await BuildsAPI.listForImage(imageId)
        let allBuilds = buildsResult?.builds ?? []

        this.setState({allBuilds: allBuilds})

        this.sub.add(async () => {
            let changeFilter = [{column: "imageIndexKey", value: imageId}]

            Socket.userBus({
                type: "requestStream",
                tableName: "Builds",
                duration: 30000,
                filter: changeFilter
            })

            return Socket.subscribeToUserBus((data) => {
                if (data.type !== "requestStream" || data.tableName !== "Builds") {
                    return
                }
                if (!Util.objects.areEqual(data.filter, changeFilter)) {
                    return
                }

                let allBuilds = this.state.allBuilds
                allBuilds = Socket.applyChange(allBuilds, data)
                allBuilds = allBuilds.sort((a, b) => (b.timestamp - a.timestamp))

                this.setState({allBuilds: allBuilds})
            })
        }, "liveData")
    }

    componentDidMount() {
        this.fetchData()


    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.imageId !== this.props.imageId) {
            this.fetchData()
        }
    }

    componentWillUnmount() {
        this.sub.unmount()
    }


    render() {
        let {allBuilds,} = this.state
        let {selectedBuild, onSelect} = this.props
        let consoleSelected = selectedBuild === ""


        return (

            <div className={" h-[30rem] flex flex-col  bg-white p-3"}>

                <div className={"mb-3"}>
                    <TextElement textType={"header"}> Release history </TextElement>
                </div>

                <div className={"overflow-y-scroll grow customScrollbar space-y-1.5 pb-10"}>
                    <div
                        onClick={() => {
                            if (onSelect !== undefined) {
                                onSelect("")
                            }
                        }}
                        className={`flex h-12 rounded space-x-3 sticky top-0 items-center p-1 cursor-pointer ${consoleSelected ? "bg-blue-700 text-white" : "bg-white text-gray-900 hover:bg-stone-100"}`}>

                        <div
                            className={`text-md font-serif w-10 p-1 text-right shrink-0`}>
                            LIVE
                        </div>
                        <div className={`text-xs`}>
                                     <span
                                         className="font-medium  flex items-center">  Live Console  </span>
                        </div>
                    </div>
                    {allBuilds.map(build => {

                        let isBuilding = build.status !== "done" && build.status !== "failed"
                        let isSelected = build.indexKey === selectedBuild
                        const duration = formatDuration(intervalToDuration({
                            start: 0, end: build.buildDuration * 1000
                        }));

                        return <div
                            onClick={() => {
                                if (onSelect !== undefined) {
                                    onSelect(build.indexKey)
                                }
                            }}
                            className={`flex  rounded space-x-3 items-center p-1 cursor-pointer ${isSelected ? "bg-blue-700 text-white" : "text-gray-900 hover:bg-stone-100"}`}>

                            <div
                                className={`text-lg font-serif w-10 pl-0.5 pr-1 text-right shrink-0 proportional-nums ${isBuilding && ("animate-pulse")}`}>
                                {build.status === "failed" ? (<>
                                    <div className={"text-red-300 text-xs"}>
                                        Failed
                                    </div>

                                </>) : (<>
                                         <span className={"text-sm"}>v.
                                        </span>
                                    {build.imageVersion.toString().padStart(3, '0')}
                                </>)}

                            </div>
                            <div className={`text-xs`}>

                                     <span
                                         className="font-medium  flex items-center">  {build.imageIndexKey} </span>
                                <div>
                                    {build.status === "done" && (<>Build
                                        duration: {duration}</>)}
                                    {build.status === "failed" && (<div className={"text-orange-500"}>The Build failed
                                        duration: {duration}
                                        {/*<div*/}
                                        {/*    className={"text-red-400 space-x-3 flex"}>{(build?.errors ?? []).map(error => {*/}
                                        {/*    return <Tooltip text={error?.errorDetail?.message}*/}
                                        {/*                    className={"border rounded border-red-500 p-1 my-1 hover:bg-red-50 cursor-pointer"}>*/}
                                        {/*        <span>{error.error}</span>*/}

                                        {/*    </Tooltip>*/}
                                        {/*})}</div>*/}
                                    </div>)}
                                    {build.status === "building" && (<div
                                        className={`flex items-center text-blue-700 ${isSelected && ("text-white")}`}>
                                        <CgSpinner
                                            className={`w-3 h-3 animate-spin shrink-0 will-change-transform mr-1`}/>
                                        building:
                                        duration:
                                        <DisplayUpdatedValue interval={500} getValue={() => {
                                            let todayTime = formatDistanceToNowStrict(build.timestamp * 1000, {includeSeconds: true})
                                            return " " + todayTime
                                        }}/>

                                    </div>)}
                                    {build.status === "pushing" && (<div
                                        className={`flex items-center  text-blue-700 ${isSelected && ("text-white")}`}>
                                        <CgSpinner
                                            className={`w-3 h-3 animate-spin shrink-0 will-change-transform mr-1`}/>
                                        pushing:
                                        duration: <DisplayUpdatedValue interval={500} getValue={() => {
                                        let todayTime = formatDistanceToNowStrict(build.timestamp * 1000, {includeSeconds: true})
                                        return " " + todayTime
                                    }}/></div>)}
                                </div>
                                {/*<BuildLogs buildId={build?.indexKey}/>*/}
                            </div>
                        </div>
                    })}
                </div>
            </div>);
    }
}

DeploymentHistory.propTypes = {};

DeploymentHistory.defaultProps = {};


export default DeploymentHistory;